module.exports = __webpack_public_path__ + "static/media/mls.cd6fe103.svg";